export default __webpack_public_path__ + "static/media/less_than_one_hundred_blue.49431618.svg";